import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Button, Icon } from 'semantic-ui-react';

class RefreshModal extends Component {

  render() {

    const { open, cancel, confirm } = this.props.modalFn;


    return(
      <Modal
        className="modal-small"
        open={open}
        onClose={cancel}>

        <Modal.Content>
          <p>이전 데이터는 모두 초기화 됩니다.</p>
          <p>새로운 정보를 입력하시겠습니까?</p>
        </Modal.Content>

        <Modal.Actions>
          <Button
            inverted color='grey'
            onClick={cancel}
            content="취소" />
          <Button
            positive
            onClick={confirm}
            content="확인" />
        </Modal.Actions>

      </Modal>
    );
  }

}

export default RefreshModal;
